'use client';

import { c as _c } from "react/compiler-runtime";
import { env } from '@cc-shopping/platform-env';
import { parseCanonicalPathname } from '@cc-shopping/utils/canonicalPathname';
import { Box } from '@mui/material';
import { usePathname } from 'next/navigation';
import type { PropsWithChildren } from 'react';
export function FAQPageWrapper(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = new URL(parseCanonicalPathname(pathname), env.NEXT_PUBLIC_NW_URL).toString();
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const canonicalUrl = t1;
  let t2;
  if ($[2] !== canonicalUrl || $[3] !== children) {
    t2 = <Box itemScope={true} itemID={canonicalUrl} itemType="https://schema.org/FAQPage">{children}</Box>;
    $[2] = canonicalUrl;
    $[3] = children;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}